<template>
  <el-input
          v-model="val"
          :disabled="disabled"
          :value="value"
          :placeholder="placeholder"
          @change="check"
          :type="type"
          v-focus="isValid"
          step="1"
  ></el-input>
</template>

<!--
  组件：接收金额输入输入框
  作用：输入框脱离焦点后马上进行金额格式校验
-->
<script>

  import {getChecker} from './checker'

  export default {
    name: "CheckInput",
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      // 输入值
      value: {
        required: true,
        default: 'price'
      },
      // 输入框占位符
      placeholder: {
        type: String,
        required: false,
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      // 校验输入框类型
      type: {
        type: String,
        required: false,
        default: 'price'
      }
    },
    data() {
      return {
        isValid: true,
        checker: {},
        checkResult: true,
        val: this.value,
        output: {
          // 原值
          original: '',
          // 格式化后的值
          format: '',
          // 检验结果
          checkResult: ''
        }
      }
    },
    created() {
      this.checker = getChecker(this.type);
    },
    methods: {
      check() {
        const checker = this.checker;
        let original = this.val;

        this.output.checkResult = checker.check(original);
        if (!this.output.checkResult) {
          this.$notifyError(checker.getHint())
        }
        // 如果format为空字符串，将它设置为 ' ' 中间有一个空格
        // 这么做是有原因的，因为如果是一次操作，返回''的话，双向绑定检测不了数据变化，数据展示就无效了
        // 这里加了一个空格，在下面watch监听的时候会把它trim()掉
        this.output.format = checker.format(original)
        this.output.original = original;
        this.$emit('update:value', this.output.format)
        this.$emit('onChange', this.output)
      },
    },
    watch: {
      value(val) {
        // val = this.checker.replace(val);
        this.val = this.checker.format(val) || ''
        this.val = this.checker.replace(val);
        // }
      }
    },
    directives: {
      focus: {
        //根据focusState的状态改变是否聚焦focus
        update: function (el, value) {
          el.focus()
          // if (value) {
          //   el.focus()
          // }
        }
      }
    }
  }
</script>

<style scoped>

</style>